import { ApiService } from "./api.service";
import { DOMAIN } from "./domain-constant";

export default class GenerateReportsService extends ApiService {
  namespace = "generate-reports";
  DOMAIN = DOMAIN.GENERATE_REPORT;
  name = "Generate reports";
  template = "defaultTemplate";
  Width = 1300;
  icon = "Checks";
  favicon = "ReceiptWithText";

  constructor() {
    super("payables");
  }
}
